import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { LoadingSpinnerService } from '../components/loading-spinner/loading-spinner.service'
import { finalize } from 'rxjs/operators'

export const SPINNER_ENABLED = new HttpContextToken<boolean>(() => true)

export const SPINNER_MESSAGE = new HttpContextToken<string>(() => '')

export const DISABLE_SPINNER_CONTEXT = new HttpContext().set(SPINNER_ENABLED, false)

export const loadingSpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(LoadingSpinnerService)
  if (req.context.get(SPINNER_ENABLED)) {
    spinnerService.show(req.context.get(SPINNER_MESSAGE))
  }
  return next(req).pipe(
    finalize(() => {
      if (req.context.get(SPINNER_ENABLED)) {
        spinnerService.hide()
      }
    })
  )
}
